export function isValidUser(businessActivities) {
  return (
    businessActivities === undefined ||
    businessActivities === null ||
    Object.keys(businessActivities).length > 0
  );
}
